<template>
    <div class="sameContainer">
        <div class="topTitle">请输入达人昵称/抖音ID，发现更多相似达人</div>
        <div class="searchContainer">
            <el-autocomplete
                class="inline-input"
                v-model="state"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
                ></el-autocomplete>
            <div class="searchBtn" @click="clickSearch"></div>
        </div>
        <span v-show="state" class="searchInfo">寻找与<strong> {{state}} </strong>相似的达人</span>
        <div v-show="JSON.stringify(tableData)!=='[]'&&state" class="otherChoose">
            <span :class="otherChoose===1?'active':''" @click="clickOtherChoose(1)">系统推荐</span>
            <span :class="otherChoose===18?'active':''" @click="clickOtherChoose(18)">粉丝重合度推荐</span>
            <span class="change" @click="changeSome">换一换</span>
        </div>
        <div v-show="JSON.stringify(tableData)==='[]'" class="nodata">
            <img src="./images/nodata.png" alt="">
            <span>暂无数据</span>
        </div>
        <div v-show="JSON.stringify(tableData)!=='[]'" class="content">
            <div class="list">
                <div class="hasData">
                    <div class="datas">
                            <div class="item" v-for="(item,index) of tableData" :key="index">
                            <img :src="item.avatar_uri" alt="">
                            <div class="info">
                                <h2>{{item.nick_name}}</h2>
                                <div class="cate">{{item.tags_content ? item.tags_content[0] : ''}}</div>
                                <div class="tags">
                                    <div class="tag" v-for="(tag, index1) of item.recommend_types" :key="index1">{{tag}}
                                    </div>
                                </div>
                            </div>
                           <div class="num">
                                <div>
                                    {{item.follower > 10000 ? ((item.follower/10000).toFixed(1) + 'w') : item.follower}}
                                </div>
                                <p>粉丝数</p>
                            </div>
                            <div class="num">
                                <div>
                                    {{item.expected_play_num > 10000 ? ((item.expected_play_num/10000).toFixed(1) + 'w') : item.expected_play_num}}
                                </div>
                                <p>预期播放量</p>
                            </div>
                            <div class="line"></div>
                            <div class="price">
                                <span>￥</span>
                                <div class="price_text">{{item.min_price.toLocaleString()}}</div>
                                <el-popover placement="bottom" width="300" trigger="hover" @show="getPriceDetail(item)">
                                    <div class="in_preview">
                                        <h3>价格预览</h3>
                                        <div class="price_item" v-for="(price_item, index2) of item.prices"
                                            :key="index2">
                                            <div class="title">{{price_item.desc}}</div>
                                            <div class="corr_price">
                                                <span>￥</span>
                                                <div class="price_t">{{price_item.price.toLocaleString()}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="preview" slot="reference"><i></i></div>
                                </el-popover>

                                <div></div>
                            </div>
                            <div class="btn" @click="tableBtnClick(item)">
                                详情
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
           return {
                nickNameArr: [],
                state: '',
                currentChoose:{value:'',id:''},
                otherChoose:1,
                tableData:[],
           }
        },
        created() {
          if(window.sessionStorage.getItem('same')){
            //   console.log(JSON.parse(window.sessionStorage.getItem('same')))
              this.currentChoose = JSON.parse(window.sessionStorage.getItem('same'))
              this.changeSome()
              this.state = this.currentChoose.value
              sessionStorage.removeItem('same')
          }
        },
        mounted(){
        },
        methods:{
            changeSome(){
                this.$api.same.getAuthorRec('/'+this.currentChoose.id,'request_source='+this.otherChoose).then((res) => {
                    this.tableData = res.data.data
                })
            },
            clickSearch(){
                LA.track('dy_find_similar');
                let curName = this.state
                let currentChoose=this.currentChoose
                let isHas=false
                this.$api.same.getAuthorList('key='+this.state).then((res) => {
                    res.data.data.authors.forEach(function(item){
                        if(item.nick_name===curName){
                            // console.log('有')
                            isHas=true
                            currentChoose.value = item.nick_name
                            currentChoose.id = item.id
                        }
                    })
                    if(isHas){
                        this.currentChoose = currentChoose
                        // console.log('this.currentChoose',this.currentChoose)
                        this.$api.same.getAuthorRec('/'+this.currentChoose.id,'request_source='+this.otherChoose).then((res) => {
                            this.tableData = res.data.data
                        })
                    }else{
                        this.tableData=[]
                    }
                })
            },
            querySearchAsync(queryString, cb) {
                let nickNameArr = []
                this.$api.same.getAuthorList('key='+queryString).then((res) => {
                    if (res.data.data.authors.length === 0) {
                        nickNameArr.push({
                            id: '-1',
                            value: '无匹配结果'
                        })
                    }else{
                        res.data.data.authors.forEach(function(item){
                            nickNameArr.push({"value":item.nick_name, "id": item.id})
                        })
                    }
                    cb(nickNameArr);
                })
            },
            createStateFilter(queryString) {
                return (state) => {
                return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                // console.log('item',item);
                this.currentChoose = item
                this.$api.same.getAuthorRec('/'+this.currentChoose.id,'request_source='+this.otherChoose).then((res) => {
                    this.tableData = res.data.data
                })
            },
            tableBtnClick(val){
                let routeData = this.$router.resolve({
                    path: '/daren',
                    query: {
                        id: val.author_id
                    }
                })
                window.open(routeData.href, "_blank");
            },
            getPriceDetail(val) {
                if (!val.prices) {
                    this.$api.getData.getDarenPrice('/' + val.author_id).then(res => {
                        // console.log(res)
                        this.tableData = this.tableData.map(t => {
                            if (t.author_id === val.author_id) {
                                t = {
                                    ...t,
                                    ...{
                                        prices: res.data.data.price_info
                                    }
                                }
                            }
                            return t
                        })
                    })
                }
            },
            clickOtherChoose(id){
                this.otherChoose = id
                this.$api.same.getAuthorRec('/'+this.currentChoose.id,'request_source='+this.otherChoose).then((res) => {
                    this.tableData = res.data.data
                })

            }
        }
    }
</script>

<style scoped>
    .sameContainer{
        width: 1200px;
        margin: 20px auto;
        padding: 26px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
        padding-bottom: 30px;
    }
    .sameContainer .otherChoose{
        width: 100%;
        height: 36px;
        margin-top: 60px;
    }
    .sameContainer .otherChoose span{
        float: left;
        margin-right: 10px;
        padding: 0 26px;
        height: 36px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        line-height: 36px;
        background: #FFFFFF;
        border: 1px solid #F0F0F0;
        border-radius: 2px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .sameContainer .otherChoose span.active{
        background: #FFFFFF;
        border: 1px solid #FF5C00;
        color: #FF6F28;
    }
    .sameContainer .otherChoose span.change{
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #38A1FF;
        border: 0;
        position: relative;
    }
    .sameContainer .otherChoose span.change::before{
        content: '';
        width: 11px;
        height: 11px;
        position: absolute;
        top: 13px;
        left: 8px;
        background: url("./images/change.png") no-repeat center;
        background-size: cover;
    }
    .sameContainer .topTitle{
        display: block;
        margin: 30px 0;
        font-size: 20px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        text-align: center;
    }
    .sameContainer .searchContainer{
        position: relative;
        margin: 0 auto;
    }
    .sameContainer .searchContainer>>>.el-input__inner{
        height: 48px;
        background: #F8F8F8;
    }
    .sameContainer .searchContainer>>>.el-input__inner:focus{
        border-color: #FF6F28;
    }
    .sameContainer .searchContainer .inline-input{
        width: 700px;
        height: 48px;
        margin-left: 250px;
        background: #F8F8F8;
        border-radius: 6px;
    }
    .sameContainer .searchContainer .searchBtn{
        position: absolute;
        right: 220px;
        top:0;
        bottom: 0;
        margin: auto 0;
        width: 20px;
        height: 20px;
        background: url("./images/search.png") no-repeat center;
        background-size: cover;
        cursor: pointer;
    }
    .sameContainer .searchInfo{
        display: block;
        margin-left: 250px;
        margin-top: 20px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #999999;
    }
    .sameContainer .searchInfo strong{
        color: #333333;
    }

    .content .list {
        margin-top: 20px;
        width: 100%;
        background: #FFFFFF;
        border-radius: 6px;
    }

    .content .list .matchingInfo {
        width: 100%;
        height: 52px;
        background: #FAFAFA;
        border-radius: 6px 6px 0px 0px;
        display: flex;
        box-sizing: border-box;
        padding: 0 26px;
        align-items: center;
    }

    .content .list .matchingInfo .title {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #A3A3A3;
        margin-right: 15px;
    }

    .content .list .matchingInfo .info {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 980px;
    }

    .content .list .matchingInfo .btn {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #FF6F28;
        margin-left: auto;
        cursor: pointer;
    }

    .content .list .rec {
        display: flex;
        box-sizing: border-box;
        padding: 0 26px;
        margin-top: 30px;
    }

    .content .list .rec h5 {
        font-size: 16px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #333333;
        margin-right: 30px;
    }

    .content .list .rec .btn {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #38A1FF;
        cursor: pointer;
    }

    .content .list .rec .btn i {
        transform: rotate(90deg);
    }

    .content .list .keywords {
        display: flex;
        align-items: center;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 0 26px;
    }

    .content .list .keywords p {
        margin-right: 20px;
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #666666;
    }

    .content .list .keywords .keyword {
        width: 90px;
        height: 29px;
        background: #FAFAFA;
        border-radius: 2px;
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #666666;
        line-height: 29px;
        text-align: center;
        cursor: pointer;
    }

    .content .list .keywords .keyword+.keyword {
        margin-left: 16px;
    }

    .content .list .keywords .keyword.active {
        box-sizing: border-box;
        line-height: 27px;
        border: 1px solid #FF5C00;
        background: #FFF2EB;
        color: #FF6F28;
    }

    .content .list .datas {
        box-sizing: border-box;
        padding: 0 26px;
    }

    .content .list .datas .item {
        display: flex;
        align-items: center;
        height: 154px;
        width: 100%;
        border-bottom: 1px solid #F0F0F0;
    }

    .content .list .datas .item:nth-last-child(1) {
        border-bottom: none;
    }

    .content .list .datas .item img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: auto;
        margin-top: 40px;
    }

    .content .list .datas .item .info {
        margin-left: 20px;
        width: 430px;
    }

    .content .list .datas .item .info h2 {
        font-size: 16px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #333333;
    }

    .content .list .datas .item .info .cate {
        display: inline-block;
        height: 26px;
        background: #F6F6F6;
        border-radius: 2px;
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        text-align: center;
        padding: 0 10px;
        margin: 12px 0;
    }

    .content .list .datas .item .info .tags {
        display: flex;
    }

    .content .list .datas .item .info .tags .tag {
        height: 24px;
        background: #FFF2EB;
        border-radius: 2px;
        font-size: 12px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #FF6F28;
        line-height: 24px;
        padding: 0 10px;
    }

    .content .list .datas .item .info .tags .tag+.tag {
        margin-left: 8px;
    }

    .content .list .datas .item .num {
        width: 100px;
    }

    .content .list .datas .item .num div {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 800;
        color: #666666;
        text-align: center;
    }

    .content .list .datas .item .num p {
        margin-top: 6px;
        font-size: 12px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #999999;
        text-align: center;
    }

    .content .list .datas .item .line {
        width: 1px;
        height: 30px;
        background: #F5F5F6;
        margin: 0 70px;
    }

    .content .list .datas .item .price {
        color: #FF5C00;
        display: flex;
    }

    .content .list .datas .item .price span {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 800;
        margin-top: 9px;
    }

    .content .list .datas .item .price .price_text {
        font-size: 20px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 800;
        color: #FF5C00;
        margin-right: 6px;
    }

    .content .list .datas .item .price .preview:hover {
        cursor: pointer;
    }

    .content .list .datas .item .price .preview i {
        display: block;
        background: url(../../assets/help/preview.png);
        width: 14px;
        height: 14px;
    }

    .content .list .datas .item .btn {
        width: 72px;
        height: 30px;
        background: #FF6F28;
        border-radius: 2px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #FFFFFF;
        margin-left: auto;
        cursor: pointer;
    }
    .content .list .datas .item .btn:hover {
        background: #FF5E0E;
    }
    .in_preview {
        padding: 24px;
        box-sizing: border-box;
    }

    .in_preview h3 {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #999999;
        height: 30px;
        border-bottom: 1px solid #F5F5F6;
    }

    .in_preview .price_item {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .in_preview .price_item .corr_price {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        color: #FF5C00;
        font-weight: 800;
        display: flex;
    }

    .in_preview .price_item .corr_price span {
        font-size: 14px;
        padding-top: 4px;
    }

    .in_preview .price_item .corr_price .price_t {
        font-size: 18px;
    }

    .nodata{
        width: 100%;
        height: 160px;
        margin: 40px 0;
    }
    .nodata img{
        display: block;
        width: 70px;
        margin: auto;
        text-align: center;
    }
    .nodata span{
        margin-top: 20px;
        display: block;
        text-align: center;
        color:#ddd;
    }
    
</style>